<div class="close-container">
    <img src="../assets/close_icon.svg" (click)="onClickClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClickClose()" (keydown.space)="$event.preventDefault(); onClickClose()" />
  </div>
  <div class="container">
    <p class="title-section font-weight-500 font-18">myQ Connected Garage Features</p>

    <div class="flex-columns justify-content-center">

        <div class="flex-container">
            <span class="side-icon"><img src="../../../../../assets/gdo/myConnectedGarageFeatures/InVehicleIcon.png" alt="feature"/></span>
            <div class="fl-box">
                <span class="title">In-Vehicle Garage Controll</span>
                <span class="content">
                    Controll your myQ connected garage doors 
                    and devices from any compatible Honda or Acura 
                    vehicle's center display using Android Auto or CarPlay.
                </span>
            </div>
        </div>
        <div class="flex-container">
            <span class="side-icon"><img src="../../../../../assets/gdo/myConnectedGarageFeatures/Smart Notification.png" alt="feature"/></span>
            <div class="fl-box">
                <span class="title">Smart Notification</span>
                <span class="content">
                    Be notified and display your myQ connected
                    garage doors and devices on your vehicle's center
                    display when you're leaving or coming home.
                </span>
            </div>
        </div>
        <div class="flex-container">
            <span class="side-icon"><img src="../../../../../assets/gdo/myConnectedGarageFeatures/Family Sharing.png" alt="feature"/></span>
            <div class="fl-box">
                <span class="title">Family Sharing</span>
                <span class="content">
                    Invite family members via myQ account to
                    access your myQ connected garage doors and
                    devices from the vehicle's center display.
                </span>
            </div>
        </div>

    </div>


    <div *ngIf="!hideCancelButton" class="action-btn-container flex wrap justify-content-center pt-5">
      <button mat-flat-button class="edit-form-button mutual-btn" (click)="onCancel()">
        Close
      </button>
      <!-- <button *ngIf="data.showAcceptBtn" mat-flat-button class="edit-form-button primar-btn" (click)="onAccept()">
        Accept
      </button> -->
    </div>
  </div>
